export default __webpack_public_path__ + "static/media/coxa-logo-gray.05610996.png";